// extracted by mini-css-extract-plugin
export default {"switchWrapper":"index-module____k6j","switchLink":"index-module__gQmrq","switchItem":"index-module__LaV6p","columnSelect":"index-module__JkbZv","heading":"index-module__mzDkI"};